import { render, staticRenderFns } from "./ViewShiftPage.vue?vue&type=template&id=395e985d&"
import script from "./ViewShiftPage.vue?vue&type=script&lang=js&"
export * from "./ViewShiftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports